<template>
  <v-row>
      <v-col cols="12">
        <template
          v-if="model.prescription"
        >
          <v-row v-if="clubsToBuild.length">
            <v-col cols="12">
              <build-club-list
                label="To build"
                :items="clubsToBuild"
                :handling="handling"
                @update="update"
              ></build-club-list>
            </v-col>
          </v-row>
          <v-row v-if="clubsAlreadyBuilt.length">
            <v-col cols="12">
              <build-club-list
                label="Already Built"
                :items="clubsAlreadyBuilt"
                :handling="handling"
                @update="update"
              ></build-club-list>
            </v-col>
          </v-row>
        </template>
        <v-row v-else>
          <v-col xs-12>
            <v-card class="mb-2">
              <v-toolbar flat color="secondary" dark>
                <v-icon left>mdi-format-list-bulleted</v-icon>
                <v-toolbar-title>Orders Rows</v-toolbar-title>
              </v-toolbar>
              <BuildRowsList
                :items="model.rows"
                :readOnly="true"
              ></BuildRowsList>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
  </v-row>
</template>

<script>
import BuildClubList from "@components/handling/BuildClubList.vue";
import BuildRowsList from "@components/handling/BuildRowsList.vue";

export default {
    components: {
        BuildClubList,
        BuildRowsList
    },
    props:{
        value: {
            type:Object,
            required:true
        },
        build: {
          type:Object,
          required:true
        },
        handling: {
          type:Object,
          required:true
        }
    },
    computed:{
        model:function(){
            return this.value;
        },
        clubQuoted () {
          let clubs = []
          clubs = clubs.concat(this.model.prescription.irons.filter(r => r.quote == 1))
          clubs = clubs.concat(this.model.prescription.wedges.filter(r => r.quote == 1))
          clubs = clubs.concat(this.model.prescription.woods.filter(r => r.quote == 1))
          clubs = clubs.concat(this.model.prescription.putters.filter(r => r.quote == 1))
          return clubs
        },
        clubsToBuild () {
          return this.clubQuoted.filter(r => r.statusBuild != 'built')
        },
        clubsAlreadyBuilt () {
          return this.clubQuoted.filter(r => r.statusBuild == 'built')
        }
    },
    methods:{
        update:function(){
            this.$emit("update");
        }
    }
}
</script>

<style>

</style>